import React from 'react';

import styled from 'styled-components';

import AiCiSectionIcon from 'components/AiCompetitiveIntelligence/AiCiSectionIcon';
import { SpeedToLeadFirstResponseRow } from 'types/recommendations';

import FirstResponseTable from './FirstResponseTable';
import { DashboardCard, SectionDescription, SectionHeading, SectionTitle } from './SpeedToLeadSection.styles';

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

type Props = {
  primaryCommunityId: number | null;
  rows: SpeedToLeadFirstResponseRow[];
};

const SpeedToLeadFirstResponse = ({ primaryCommunityId, rows }: Props) => (
  <DashboardCard $muted>
    <SectionHeading>
      <AiCiSectionIcon src="/icons/phone-in-talk.svg" />
      <div>
        <SectionTitle>First Response Stats</SectionTitle>
        <SectionDescription>
          First response across general and phone response statistics, shown in minutes.
        </SectionDescription>
      </div>
    </SectionHeading>
    <TwoColumnGrid>
      <FirstResponseTable
        title="First Response Speed (Any Channel)"
        rows={rows}
        primaryCommunityId={primaryCommunityId}
        getEvent={(row) => row.first_response}
      />
      <FirstResponseTable
        title="First Phone Contact Attempt"
        rows={rows}
        primaryCommunityId={primaryCommunityId}
        getEvent={(row) => row.first_phone_attempt}
      />
    </TwoColumnGrid>
  </DashboardCard>
);

export default SpeedToLeadFirstResponse;
